import { SxProps } from "@mui/material";
import { useEffect, useState } from "react";
import { assetService } from "../../../Core/Api/services";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { GetSelectedItems, GetTreeObj, TreeContext } from "../../../Redux/Reducers/redux-slice-tree";
import { useAppSelector } from "../../../Redux/redux-store";
import AssetTreeView from "../TitleTreeView/asset-tree-view-2";
export interface MoveAssetTreeViewProps {
  sx?: SxProps;
  className?: string;
  // Given object root Id
  treeRootId: number;
  selectableObjectLayers?: ObjectLayer[];
  objectsIdsToDisable: number[];
  objectIdsToHilight: number[];
}

const MoveAssetTreeView: React.FC<MoveAssetTreeViewProps> = (props) => {
  const { treeRootId, selectableObjectLayers, objectsIdsToDisable, objectIdsToHilight, ...otherProps } = props;

  const [disabledIds, setDisabledIds] = useState<number[]>([]);
  const graph = useAppSelector(GetTreeObj(TreeContext.MoveDistrib));

  useEffect(() => {
    if (!graph) return;

    if (selectableObjectLayers) {
      const [selectableIds, disabledIds] = assetService.GetGraphIdsThatMatchObjectLayer(
        graph,
        selectableObjectLayers,
        objectsIdsToDisable,
        true
      );

      setDisabledIds(disabledIds);
    }
  }, [graph]);

  return (
    <>
      <AssetTreeView
        rootObjectId={treeRootId}
        context={TreeContext.MoveDistrib}
        multiselect={false}
        disableNavigation
        unselectableIds={[treeRootId, ...disabledIds]}
      />
    </>
  );
};

export default MoveAssetTreeView;
